import { render, staticRenderFns } from "./GetCode.vue?vue&type=template&id=1d79fcf8&scoped=true"
import script from "./GetCode.vue?vue&type=script&lang=js"
export * from "./GetCode.vue?vue&type=script&lang=js"
import style0 from "./GetCode.vue?vue&type=style&index=0&id=1d79fcf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d79fcf8",
  null
  
)

export default component.exports